import { render, staticRenderFns } from "./MessageContent.vue?vue&type=template&id=7b0bd05c&scoped=true"
import script from "./MessageContent.vue?vue&type=script&lang=ts"
export * from "./MessageContent.vue?vue&type=script&lang=ts"
import style0 from "./MessageContent.vue?vue&type=style&index=0&id=7b0bd05c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b0bd05c",
  null
  
)

export default component.exports